import { render } from "./BaseIcon.vue?vue&type=template&id=21243c4d"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import "./BaseIcon.vue?vue&type=style&index=0&id=21243c4d&lang=css"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__